// extracted by mini-css-extract-plugin
module.exports = {"PendingContainer":"Pending_PendingContainer__p8RNO","Header":"Pending_Header__9Jnt7","Subtitle":"Pending_Subtitle__ygoiN","Spinner":"Pending_Spinner__JWPek"};